<template>
  <div class="page verantwortung">
    <progress max="100" value="0"></progress>
    <video-background
      :src="require(`@/assets/videos/EnBW_ODR_Bluehwiesen_Bopfingen.mp4`)"
      style="max-height: 600px; min-height: 600px; height: calc(100vh - 350px)"
    >
      <section id="section-video" class="main-banner">
        <div class="banner-content">
          <div class="container">
            <h1 class="headline-h1">
              Wir handeln umweltbewusst<br />
              und verantwortungsvoll
            </h1>
          </div>
        </div>
      </section>
    </video-background>
    <section class="section section__vw">
      <div class="container">
        <div class="content-wrapper">
          <h3>Nachhaltigkeit bei der ODR</h3>
          <p>
            Alles, was wir tun, tun wir mit dem Gedanken an unsere Umwelt und
            dem Weitblick auf kommende Generationen. Als Energieversorger tragen
            wir eine besondere Verantwortung, denn mehr als 80 Prozent der
            Treibhausgasemissionen in Deutschland stammen aus der
            Energieversorgung (Umweltbundesamt 2022). Die Zukunft liegt deshalb
            in den erneuerbaren Energien. 2022 stammten bereits 74 Prozent des
            Stroms im Versorgungsgebiet der ODR rein bilanziell aus
            regenerativen Energiequellen. Nicht nur in der Energieversorgung
            handeln wir umweltbewusst, wir haben den Klima- und Umweltschutz
            auch in allen Bereichen unserer Unternehmensstruktur fest verankert.
          </p>
          <p></p>
          <h3>Nachhaltig zertifiziert</h3>
          <p>
            Klimaneutralität kann nur durch konkretes Handeln erreicht werden.
            Deshalb setzen wir bei der EnBW ODR auf tatsächliche Einsparungen
            von Treibhausgasen. Das belegen wir seit 2021 gemäß
            EMAS-Umweltmanagement (Eco-Management and Audit Scheme). Unsere
            Maßnahmen veröffentlichen wir transparent in unserer Umwelterklärung
            auf unserer Website.
          </p>
        </div>
      </div>
    </section>

    <section class="section section_02" style="padding: 0">
      <b-container fluid class="impulse-container">
        <b-row>
          <b-col sm="12" md="2"></b-col>
          <b-col sm="12" md="10">
            <div class="main-impulse">
              <b-container fluid>
                <b-row align-v="stretch">
                  <b-col sm="12" md="4" class="item-impulse content-wrapper">
                    <h4><strong>74 %</strong> E-Strom</h4>
                    <p>
                      im Versorgungsgebiet der ODR rein bilanziell aus
                      regenerativen Energiequellen
                    </p>
                  </b-col>
                  <b-col sm="12" md="4" class="item-impulse content-wrapper">
                    <h4><strong>EMAS</strong> ISO 50001</h4>
                    <p>weltweit gültige Norm für Energiemanagementsysteme</p>
                  </b-col>
                  <b-col csm="12" md="4" class="item-impulse content-wrapper">
                    <h4><strong>EMAS</strong> ISO 14001</h4>
                    <p>Umweltmanagementnorm</p>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="section section_03">
      <div class="container">
        <div class="content-wrapper">
          <h3>Nachhaltig agiert</h3>
          <p>
            Wir setzen regelmäßig Maßnahmen um, die unserer Umwelt zugutekommen.
            2022 haben wir das Projekt Blühstreifen an landwirtschaftlichen
            Nutzflächen ins Leben gerufen. Gemeinsam mit dem Bauernverband
            Ostalb-Heidenheim fördern wir das Ausbringen von heimischem Saatgut
            und tragen damit zum Erhalt der Artenvielfalt bei. Ein drei
            Quadratkilometer großer Blühstreifen wurde bisher realisiert, für
            das Jahr 2023 konnten wir bereits neun weitere Landwirte gewinnen.
            Ebenfalls in Kooperation mit einem regionalen Landwirt kümmern sich
            tierische Landschaftspfleger um unser Gelände am Umspannwerk in
            Giengen an der Brenz. Ziegen grasen auf der Wiesenfläche und halten
            das Gras um die Anlagen kurz.
          </p>
          <p>
            Unsere Mitarbeitenden packen auch regelmäßig selbst für den
            Umweltschutz mit an: Für jeden Kunden, der im ODR-Kundenzentrum
            Online auf eine digitale Rechnung umstellt, pflanzt die ODR einen
            Baum für den regionalen Klimaschutz. So haben wir zwischen 2016 und
            Ende 2022 schon insgesamt über 16.000 heimische Laub- und Nadelbäume
            in Ostwürttemberg und der Region Donau-Ries in enger Kooperation mit
            15 Kommunen und der Schutzgemeinschaft Deutscher Wald gepflanzt.
            Tatkräftig unterstützt werden unsere Mitarbeitenden von Kindergärten
            und Schulen. Damit fördern wir auch das kindliche Gespür für
            Naturschutz.
          </p>
        </div>
      </div>
    </section>

    <section class="section section_03 section__bg-white" style="padding: 0">
      <div class="jarallax jarallax_section">
        <img
          src="../assets/images/verantwortung/parallax_section_03.jpg"
          alt=""
          class="jarallax-img"
        />
        <div class="jarallax_content">
          <div class="container">
            <div class="headline-impulse">
              <h2>
                <strong>Projekt Blühstreifen</strong>
                gemeinsam mit dem Bauernverband Ostalb-Heidenheim
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section_02 section__bg-dark_grey">
      <div class="container">
        <div class="content main-gallery">
          <vueper-slides
            class="no-shadow"
            autoplay
            :visible-slides="3"
            :gap="5"
            :bullets="false"
            :slide-ratio="1 / 5"
            :infinite="false"
            :duration="4000"
            :dragging-distance="20000"
            :breakpoints="{
              1023: { visibleSlides: 3, slideRatio: 1 / 5 },
              800: { visibleSlides: 2, slideRatio: 1 / 3 },
              500: { visibleSlides: 1, slideRatio: 4 / 6 },
            }"
          >
            <vueper-slide
              v-for="(slide, i) in slides"
              :key="i"
              :image="slide.image"
              :title="slide.title"
              :content="slide.content"
            />
          </vueper-slides>
        </div>
      </div>
    </section>
    <div class="main-nav-section">
      <div class="container">
        <router-link to="/anspruch" tag="div"
          ><a class="link link__back"></a
        ></router-link>
        <router-link to="/stabilitaet" tag="div"
          ><a class="link link__next"></a
        ></router-link>
      </div>
    </div>
  </div>
</template>
<script>
import "object-fit-images";
import { jarallax, jarallaxVideo } from "jarallax";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "Verantwortung",
  components: { VueperSlides, VueperSlide },

  data: () => ({
    slides: [
      {
        //title: "Aufhausen",
        image: require("@/assets/images/verantwortung/gallery/img_01.jpg"),
      },
      {
        //title: "Möttingen",
        image: require("@/assets/images/verantwortung/gallery/img_02.jpg"),
      },
      {
        //title: "Harburg",
        image: require("@/assets/images/verantwortung/gallery/img_03.jpg"),
      },
      {
        //title: "Täferrot",
        image: require("@/assets/images/verantwortung/gallery/img_04.jpg"),
      },
      {
        //title: "Gundelfingen",
        image: require("@/assets/images/verantwortung/gallery/img_05.jpg"),
      },
    ],
    numberFrom: 0,
    numberTo: 140,
    duration: 5,
    scaleClass: false,
  }),

  mounted: function () {
    window.scrollTo(0, 0);
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      gsap.to("progress", {
        value: 100,
        ease: "none",
        scrollTrigger: { scrub: 0.15 },
      });

      const impluse = document.querySelector(".main-impulse");
      gsap.from(impluse, {
        x: "100%",
        opacity: 0,
        duration: 1,
        scrollTrigger: {
          trigger: impluse,
          toggleActions: "play none none none",
          start: "bottom bottom",
          end: "top top",
        },
      });

      const tl = gsap.timeline({ defaults: { duration: 0.7, opacity: 0 } });
      tl.from("#ard_r, #ard_l", { delay: 0, y: -50 });
      tl.from("#ven", { delay: 0.5, scaleY: 0, transformOrigin: "bottom" });
      tl.from("#mann", { delay: 0.5, y: -100 }, "=.1");

      const contentBlocs = gsap.utils.toArray(".content-wrapper");
      contentBlocs.forEach((contentBloc) => {
        gsap.from(contentBloc, {
          y: 50,
          delay: 1.5,
          opacity: 0,
          duration: 1,
          scrollTrigger: {
            trigger: contentBloc,
            toggleActions: "play pause resume reset",
          },
        });
      });

      const animCharts = gsap.utils.toArray(".anim-chart");
      animCharts.forEach((animChart) => {
        gsap.from(animChart, {
          scale: 0,
          opacity: 0,
          duration: 2,
          scrollTrigger: {
            trigger: animChart,
            toggleActions: "play pause resume reset",
          },
        });
      });

      const bubble = document.querySelector(".main-bubble");
      gsap.from(bubble, {
        scale: 0,
        opacity: 0,
        duration: 1.5,
        scrollTrigger: {
          trigger: bubble,
          toggleActions: "play pause resume reset",
          start: "bottom bottom",
          end: "top top",
        },
      });

      jarallaxVideo();
      jarallax(document.querySelectorAll(".jarallax"), {
        speed: 0.2,
      });
    },
  },
};
</script>

<style lang="scss">
@import "./../scss/views/verantwortung.scss";
</style>
